import { EvaluationScores } from '../../enums/evaluation-scores.enum';

export const EVALUATION_SCORES_VALUES = {
  [EvaluationScores.BelowExpectations]: 'BELOW_EXPECTATIONS',
  [EvaluationScores.ApproachingExpectations]: 'APPROACHING_EXPECTATIONS',
  [EvaluationScores.MeetsExpectations]: 'MEETS_EXPECTATIONS',
  [EvaluationScores.ExceedsExpectations]: 'EXCEEDS_EXPECTATIONS',
};
